import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

type SnippetProps = {
  children: string;
  className?: string;
};

const Snippet = ({ children, className }: SnippetProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(children);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={cn("flex w-full items-center", className)}>
      <Input
        type="text"
        readOnly
        value={children}
        className="w-full flex-1 border-none bg-transparent text-white"
      />
      <Button
        type="button"
        onClick={handleCopy}
        size="icon"
        className="bg-transparent p-0 text-white hover:bg-transparent"
      >
        {copied ? (
          <Check size={16} color="#3e9392" />
        ) : (
          // <img src="/assets/Copy.svg" alt="Shark Icon" className="h-5 w-5" />
          <img src="/assets/Copy.svg" alt="Shark Icon" className="h-5 w-5" />
          // <Copy size={16} color="#3e9392" />
        )}
      </Button>
    </div>
  );
};

export default Snippet;
